import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export default function BlogTags({ tags, title }: { tags: string[]; title: string }) {
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // ignore
    }
  }, []);

  const shareUrl = encodeURIComponent(window.location.href);
  const shareTitle = encodeURIComponent(title);

  return (
    <footer className="mt-2 flex flex-wrap items-center justify-between gap-4 border-t border-secondary-200 pt-5">
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <span
            key={tag}
            className="rounded-[18px] border border-secondary-200 bg-white px-3 py-1.5 text-[12px] font-semibold text-secondary-600"
          >
            {tag}
          </span>
        ))}
      </div>
      <div className="flex items-center gap-2">
        <span className="mr-1 text-[12.5px] font-semibold text-secondary-400">
          {t('blog.share')}
        </span>
        <button
          type="button"
          aria-label={t('blog.copyLink')}
          onClick={handleCopy}
          className="grid size-9 place-items-center rounded-[10px] border border-secondary-200 bg-white text-secondary-600 transition-colors hover:-translate-y-0.5 hover:border-primary-300 hover:text-primary-700"
        >
          <i className={`ri-${copied ? 'check-line' : 'link'} text-sm`} />
        </button>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('blog.shareFacebook')}
          className="grid size-9 place-items-center rounded-[10px] border border-secondary-200 bg-white text-secondary-600 transition-colors hover:-translate-y-0.5 hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-facebook-fill text-sm" />
        </a>
        <a
          href={`https://wa.me/?text=${shareTitle}%20${shareUrl}`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('blog.shareWhatsApp')}
          className="grid size-9 place-items-center rounded-[10px] border border-secondary-200 bg-white text-secondary-600 transition-colors hover:-translate-y-0.5 hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-whatsapp-line text-sm" />
        </a>
      </div>
    </footer>
  );
}